import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TimetableDataService {
  private readonly apiUrl = 'api-mock';

  constructor(private readonly http: HttpClient) {}

  public loadTimeTableMonthlyData(): Observable<any> {
    return this.http.get<Event[]>(`${this.apiUrl}/timetable-monthly-data`).pipe(take(1));
  }
}
